import React from "react";
import AdminLayout from "layout/AdminLayout";

export default class TestPage extends React.PureComponent {
  render() {
    return <AdminLayout />;
  }
}
